/** Builds an i18n key under the namespace the modal owns for its own labels. */
export const buildOwnLabel = (name: string) =>
  `confirmRuleUpdates.fields.${name}`;

/** Item key for lists of plain values. */
export const getItemKeyByValue = (item: unknown) => String(item);
